@if (service.isLoading) {
<div class="my-3 text-center">
  <circular-spinner iconClass="icon-64 text-success"></circular-spinner>
</div>
}@else {
<div class="bg-primary text-white modal-header pt-3">
  <h3 class="mt-0 modal-title text-center mx-auto" id="modal-basic-title">
    <span translate>Order #</span>{{ service.order?.order_id }}
  </h3>
  <button class="btn-close btn-red" (click)="dismiss()"></button>
</div>
<div class="p-3 modal-body bg-primary-gradient text-white" translate>
  <div class="d-flex justify-content-between mb-2">
    <div>
      <i class="align-middle icon-lg icon icon-shipping-fast me-2"></i>
      {{ service.order?.order_type }}
    </div>
    <div class="">
      {{ service.order?.order_state }}
    </div>
  </div>
  <div class="bg-light-transparent-3">
    @for (item of service.order?.order_items; track item.order_item_id) {
    <div class="p-3 border-bottom border-white">
      <div class="d-lg-flex justify-content-between">
        <div>
          <span>{{ item.title }}</span>
        </div>
        <div>
          <span class="me-1" translate>SKU:</span>
          <span>{{ item.sku }}</span>
        </div>
      </div>
      <div class="d-lg-flex justify-content-between">
        <div>
          <span class="me-1" translate>Quantity:</span>
          <span>{{ item.quantity }}</span>
        </div>
        <div>
          <i class="icon icon-donate me-2"></i>
          <span>{{ item.total_price }} {{ item.total_currency }}</span>
        </div>
      </div>
      <div class="d-lg-flex justify-content-between">
        <div>
          <span class="me-1" translate>Start date:</span>
          <span>{{ service.order?.completed }}</span>
        </div>
        @if (service.order?.next_renewal) {
        <div>
          <span class="me-1" translate>Renewal date:</span>
          <span>{{ service.order?.next_renewal | i18nDate : 'dd MMMM yyyy' }}</span>
        </div>
        }
      </div>
    </div>
    }
  </div>
  @if (service.order?.order_items > 1) {
  <div class="text-success d-flex justify-content-end">
    <span class="me-1" translate>Total:</span>
    {{ service.order?.total_price }} {{ service.order?.total_currency }}
  </div>
  }
</div>
}
